import React, { useState } from 'react';
import './Faqs.css';

import { FaqItem } from '../../../../components';
import { faqsContent, images } from '../../../../constants';
import { useTranslation } from 'react-i18next';
 

const Faqs = () => { 
 
  // State to manage the active accordion for container 1
  const [activeAccordionId, setActiveAccordionId] = useState(faqsContent[0].id);

  // Function to handle accordion click event for container 1
  const handleAccordionClick = (id) => {
    setActiveAccordionId((prevId) => (prevId === id ? null : id));
  };
  const { t } = useTranslation();

  
  return (
    <> 

      <section className='faq'>

        {/* Faq Accordion container */}
        <div className='accordion-container'>
          {/* Faq items */}
          {faqsContent.map((faq) => {
            return (            
              <FaqItem
                key={faq.id}
                id={faq.id}
                title={faq.heading}
                content={faq.content}
                isActive={faq.id === activeAccordionId}
                onAccordionClick={handleAccordionClick}
              /> )
          })}
        </div>

        {/* Faq Image */}
        <div className='image'>
          <img src={images.faqs} alt='FAQs-Pic' /> 
        </div>
        
      </section>
    </>
  );
};

export default Faqs;